module.exports = __webpack_public_path__ + "img/logo-big.ded0d097.svg";